import { useToast } from 'primevue/usetoast';
import { useGetData } from '~/composables/useGetData';
import { $parseErrorMessage, $sanitizeHtml } from '~/utils/helpers';

export default function useGetTermsOfUse() {
  const termsOfUse = ref<string>();
  const loading = ref(false);

  const toast = useToast();

  const getTermsOfUse = async () => {
    if (loading.value) return;

    loading.value = true;

    try {
      const { execute, error } = await useGetData<{
        data: { content: string };
      }>();
      const result = await execute('pages/terms_of_service', {
        query: {
          raw: 1,
        },
      });

      if (error.value) {
        toast.add({
          severity: 'error',
          summary: $parseErrorMessage(error.value),
          life: 3000,
        });
      } else if (result.data && result.data.content) {
        termsOfUse.value = $sanitizeHtml(result.data.content);
      }
    } catch (err) {
      toast.add({
        severity: 'error',
        summary: $parseErrorMessage(err),
        life: 3000,
      });
    }

    loading.value = false;
  };

  return {
    termsOfUse,
    loading,

    getTermsOfUse,
  };
}
